export default __webpack_public_path__ + "static/timberline-video-cover-58ebafece58769af8ae9c3c543932c8b.jpg";